type GlobalErrorHandler = (message: string, status?: number) => void;

let globalErrorHandler: GlobalErrorHandler | null = null;

export const registerGlobalErrorHandler = (handler: GlobalErrorHandler) => {
  globalErrorHandler = handler;
};

export const displayGlobalError = (message: string, status?: number) => {
  if (globalErrorHandler) {
    globalErrorHandler(message, status);
  } else {
    console.error("Global error handler not registered. Error:", message, "Status:", status);
    // Fallback to a simple alert or console log if the handler isn't ready
    alert(`API Error: ${message} (Status: ${status || 'N/A'})`);
  }
};